/** Coordinate mobile scrolling with the theme's media selection and thumbnails. */
(function() {
  'use strict';

  function initProductGallery() {
    document.querySelectorAll('product-images').forEach((gallery) => {
      const slider = gallery.querySelector('[data-product-media-list]');
      if (!slider || slider.dataset.mobileNavBound === 'true') return;
      slider.dataset.mobileNavBound = 'true';

      const slides = Array.from(slider.querySelectorAll('[data-image-id]'));
      const isScrollMode = () => window.matchMedia('(max-width: 749px)').matches &&
        gallery.classList.contains('product__images--mobile-slider');
      const behavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      let syncingScroll = false;
      let scrollTimer;
      let pendingMediaId = null;

      // Measure relative to the scroller, including any page/grid offset.
      const slideLeft = (slide) => slide.getBoundingClientRect().left -
        slider.getBoundingClientRect().left + slider.scrollLeft - slider.clientLeft;
      const nearestSlide = () => slides.reduce((nearest, slide) => {
        return Math.abs(slideLeft(slide) - slider.scrollLeft) <
          Math.abs(slideLeft(nearest) - slider.scrollLeft) ? slide : nearest;
      }, slides[0]);
      const select = (slide) => {
        if (!slide) return;
        gallery.dispatchEvent(new CustomEvent('theme:media:select', {
          bubbles: true,
          detail: { id: slide.getAttribute('data-media-id') }
        }));
      };

      // product-thumbs owns thumbnail clicks. Use its single selection event.
      gallery.addEventListener('theme:media:select', (event) => {
        const selected = slides.find((slide) => slide.getAttribute('data-media-id') === event.detail.id);
        if (!selected) return;
        selected.querySelector('img')?.setAttribute('loading', 'eager');
        gallery.querySelectorAll('[data-thumb-link]').forEach((link) => {
          link.setAttribute('aria-current', String(link.getAttribute('data-media-id') === event.detail.id));
        });
        if (!isScrollMode() || syncingScroll) return;
        pendingMediaId = event.detail.id;
        slider.scrollTo({ left: slideLeft(selected), behavior: behavior() });
      });

      slider.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          if (!isScrollMode()) return;
          pendingMediaId = null;
          const slide = nearestSlide();
          if (!slide || slide.getAttribute('data-media-id') === gallery.getAttribute('data-active-media')) return;
          // Keep the theme's active slide and thumbnail in sync after swiping.
          syncingScroll = true;
          select(slide);
          syncingScroll = false;
        }, 120);
      }, { passive: true });

      const navigate = (direction) => {
        if (slides.length < 2) return;
        const activeId = pendingMediaId || gallery.getAttribute('data-active-media');
        const current = Math.max(0, slides.findIndex((slide) => slide.getAttribute('data-media-id') === activeId));
        select(slides[(current + direction + slides.length) % slides.length]);
      };
      gallery.querySelectorAll('[data-mobile-arrow-prev], [data-mobile-arrow-next]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          navigate(button.hasAttribute('data-mobile-arrow-next') ? 1 : -1);
        });
      });

      document.addEventListener('theme:resize:width', () => {
        if (!gallery.isConnected) return;
        clearTimeout(scrollTimer);
        pendingMediaId = null;
        const active = slides.find((slide) => slide.getAttribute('data-media-id') === gallery.getAttribute('data-active-media'));
        slider.scrollTo({ left: isScrollMode() && active ? slideLeft(active) : 0, behavior: 'instant' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGallery);
  } else {
    initProductGallery();
  }
  document.addEventListener('shopify:section:load', initProductGallery);
  document.addEventListener('theme:product-info:loaded', initProductGallery);
  document.addEventListener('theme:variant:change', initProductGallery);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) initProductGallery();
  });
  observer.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();
